module.exports = __webpack_public_path__ + "img/202306_06.75277ff0.jpg";